import { Skeleton } from "@mui/material";

export const MilestoneTimelineSkeleton = () => {
    return (
        <Skeleton
            animation="wave"
            variant="rectangular"
            width="30%"
            height="50vh"
        />
    );
};
